var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-dialog",
    {
      class: { "custom-padding": _vm.padding },
      attrs: {
        "md-active": _vm.active,
        "md-close-on-esc": false,
        "md-click-outside-to-close": false,
        "data-notif-id": _vm.values.notif_id
      },
      on: {
        "update:mdActive": function($event) {
          _vm.active = $event
        },
        "update:md-active": function($event) {
          _vm.active = $event
        }
      }
    },
    [
      _c("md-dialog-title", [_vm._v(_vm._s(_vm.i18n.lbl_limit_s()))]),
      _vm._v(" "),
      _vm.values.client_wallet
        ? _c("detail", {
            attrs: {
              prop: _vm.i18n.lbl_client_wallet(),
              value: _vm.values.client_wallet,
              copiable: true
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.values.client_hash
        ? _c("detail", {
            attrs: {
              prop: _vm.i18n.lbl_client_hash(),
              value: _vm.values.client_hash,
              copiable: true
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("detail", {
        attrs: {
          prop: _vm.i18n.lbl_one_time_wallet(),
          value: _vm.values.wallet,
          copiable: true
        }
      }),
      _vm._v(" "),
      _c("detail", {
        attrs: { prop: _vm.i18n.lbl_asset(), value: _vm.formatToken }
      }),
      _vm._v(" "),
      _vm.values.amount
        ? _c("detail", {
            attrs: { prop: _vm.i18n.lbl_amount(), value: _vm.amount }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.values.order_no
        ? _c("detail", {
            attrs: {
              prop: _vm.i18n.lbl_order_id(),
              value: _vm.values.order_no,
              copiable: true
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.values.order_amount
        ? _c("detail", {
            attrs: { prop: _vm.i18n.lbl_order_amount(), value: _vm.orderAmount }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.values.order_network
        ? _c("detail", {
            attrs: {
              prop: _vm.i18n.lbl_order_network(),
              value: _vm.values.order_network
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.values.timeStamp
        ? _c("detail", {
            attrs: {
              prop: _vm.i18n.lbl_time_optional(),
              value: _vm.values.timeStamp
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "md-dialog-actions",
        [
          _c(
            "md-button",
            {
              staticClass:
                "md-button btn md-primary md-theme-default w-100 md-yellow",
              attrs: { disabled: _vm.isLoading },
              on: { click: _vm.submit }
            },
            [
              _vm._v(_vm._s(_vm.i18n.lbl_got_it()) + "\n      "),
              _c("md-tooltip", { attrs: { "md-direction": "bottom" } }, [
                _vm._v(_vm._s(_vm.i18n.lbl_delete_notif()))
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4dee13fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dee13fa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/navigation/LymitDialog.vue
// module id = o6Ym
// module chunks = 1